import { jsx as _jsx } from "react/jsx-runtime";
import { useI18N, useTheme } from "@sundae/react-hooks";
import { Loader, QuestionMarkCircledIcon, toolkitCx, Tooltip, Header as UIHeader, } from "@sundae/ui-toolkit";
import { useWalletLoadingState, useWalletObserver } from "@sundaeswap/wallet-lite";
import cx from "classnames";
import { lazy, Suspense, useCallback, useMemo } from "react";
import { EEX_PATHS, EPATHS } from "../../constants/paths";
import { usePermissions } from "../../hooks";
import { useAppContext } from "../../stores";
import WalletButton from "../WalletButton";
const LazyWalletDetails = lazy(() => import("../WalletDetails/WalletDetails"));
export const Header = () => {
    const { currentLocale, t } = useI18N();
    const { state: { componentProps }, } = useAppContext();
    const { theme, toggleTheme } = useTheme();
    const { activeWallet, mainAddress } = useWalletObserver();
    const { ready } = useWalletLoadingState();
    const { canCreate } = usePermissions();
    const defaultNavItems = useMemo(() => [
        {
            to: EPATHS.PROPOSAL_OVERVIEW,
            title: t("navigation.home"),
        },
        {
            to: EPATHS.CREATE_PROPOSAL,
            title: t("navigation.create"),
        },
        {
            to: EEX_PATHS.FORUM,
            title: t("navigation.forum"),
            external: true,
            target: "_blank",
        },
        {
            dropdown: {
                menuTitle: t("navigation.more"),
                menuContent: [
                    {
                        to: EEX_PATHS.TWITTER,
                        title: t("navigation.twitter"),
                        description: t("navigation.twitter", { context: "description" }),
                        external: true,
                    },
                    {
                        to: EEX_PATHS.DISCORD,
                        title: t("navigation.discord"),
                        description: t("navigation.discord", { context: "description" }),
                        external: true,
                    },
                    {
                        to: EEX_PATHS.MEDIUM,
                        title: t("navigation.medium"),
                        description: t("navigation.medium", { context: "description" }),
                        external: true,
                    },
                ],
            },
        },
    ], [currentLocale]);
    const WalletButtonWithState = useCallback(() => {
        if (activeWallet && !mainAddress) {
            return _jsx(WalletButton, { size: "sm" });
        }
        return (_jsx(Suspense, { fallback: _jsx("div", { className: cx("w-200 mx-8", toolkitCx.recipes.center.both()), children: _jsx(Loader, { size: "small" }) }), children: _jsx(LazyWalletDetails, {}) }));
    }, [activeWallet, mainAddress]);
    const mergedProps = useMemo(() => {
        const merged = {
            theme,
            toggleTheme,
            homepageLinkHref: EPATHS.PROPOSAL_OVERVIEW,
            homepageLinkTitle: t("meta.title"),
            isConnected: ready,
            renderWalletButton: WalletButtonWithState,
            showThemeToggle: true,
            renderTertiaryNav: ({ HeaderButton }) => (_jsx(Tooltip, { trigger: _jsx(HeaderButton, { onClick: () => window.open(componentProps?.header?.faqUrl ? componentProps.header.faqUrl : EEX_PATHS.FAQ, "_blank"), children: _jsx(QuestionMarkCircledIcon, {}) }), tooltipLabel: "Visit our FAQ" })),
            ...componentProps?.header,
        };
        if (!ready || !canCreate) {
            const disconnectedNavItems = merged.navigationItems?.filter(({ to }) => to !== EPATHS.CREATE_PROPOSAL);
            return {
                ...merged,
                navigationItems: disconnectedNavItems,
            };
        }
        return merged;
    }, [componentProps?.header, defaultNavItems, ready, theme, canCreate]);
    return _jsx(UIHeader, { ...mergedProps });
};
export default Header;
//# sourceMappingURL=Header.js.map